import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { PersonalDataAndAccountsPage } from "web_myplann/Profile/Pages/PersonalDataAndAccountsPage";
import { PersonalDataV2Page } from "web_myplann/Profile/Pages/PersonalDataV2Page";

export const PersonalDataPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? (
		<PersonalDataV2Page />
	) : (
		<PersonalDataAndAccountsPage />
	);
};
